/**
 * Font Handling Utilities
 * 
 * This script provides workarounds for font rendering issues:
 * 1. Fixes the Pricedown font's capital "I" in combinations like "KI", "DI", "PI"
 * 2. Handles the all-caps nature of the fonts
 */

document.addEventListener('DOMContentLoaded', function() {
    // Get references to the elements
    const mapTitleInput = document.getElementById('map-title-input');
    const mapTitlePreview = document.getElementById('map-title-preview');
    const mapSubtitleInput = document.getElementById('map-subtitle-input');
    const mapSubtitlePreview = document.getElementById('map-subtitle-preview');
    
    // Override the default input event listeners with our custom handlers
    if (mapTitleInput && mapTitlePreview) {
        // Remove any existing listeners (from main.js)
        const oldTitleListener = mapTitleInput.onchange;
        mapTitleInput.removeEventListener('input', oldTitleListener);
        
        // Add our custom listener for the title
        mapTitleInput.addEventListener('input', function(e) {
            // Get the input value
            let text = e.target.value;
            
            // Apply special handling for problematic letter combinations
            text = fixPricedownIssues(text);
            
            // Update the preview
            mapTitlePreview.textContent = text;
        });
        
        // Trigger the handler once to fix any existing text
        mapTitleInput.dispatchEvent(new Event('input'));
    }
    
    // Initial sync for subtitle (no special handling needed beyond what's in main.js)
    if (mapSubtitlePreview && mapSubtitleInput) {
        mapSubtitlePreview.textContent = mapSubtitleInput.value;
    }
});

/**
 * Fixes Pricedown font issues with capital I in certain combinations
 * 
 * @param {string} text - The input text
 * @return {string} - The fixed text
 */
function fixPricedownIssues(text) {
    // Handle problematic combinations by inserting a zero-width space
    // between certain letters and capital I
    return text.replace(/([KDP])I/g, '$1\u200BI');
}
